import { NetworkNames } from './NetworkNames';
import { getStaticImagePaths } from '@/utils/getStaticImages';

const staticImages = Object.fromEntries(getStaticImagePaths());
export const NETWORK_DATA = {


  [NetworkNames.ADGATEMEDIA]: {
    image: staticImages.ADGATEMEDIA,
    url: 'https://wall.adgaterewards.com',
  },


  [NetworkNames.CPXRESEARCH]: {
    image: staticImages.CPXRESEARCH,
    url: 'https://offers.cpx-research.com/index.php',
  },


  [NetworkNames.ADGEM]: {
    image: staticImages.ADGEM,
    url: 'https://api.adgem.com/v1/wall',
  },


  [NetworkNames.ADSCENDMEDIA]: {
    image: staticImages.ADSCENDMEDIA,
    url: 'https://asmwall.com/adwall/publisher/110961/profile/',
  },

  [NetworkNames.AYETSTUDIOS]: {
    image: staticImages.AYETSTUDIOS,
    url: 'https://www.ayetstudios.com/offers/web_offerwall/',
  },


  [NetworkNames.TOROX]: {
    image: staticImages.TOROX,
    url: 'https://torox.io/ifr/show',
  },


  [NetworkNames.WANNADS]: {
    image: staticImages.WANNADS,
    url: 'https://earn.wannads.com/wall',
  },


  [NetworkNames.PERSONALY]: {
    image: staticImages.PERSONALY,
    url: 'https://www.personaly.com',
  },

  
  [NetworkNames.INBRAIN]: {
    image: staticImages.INBRAIN,
    url: 'https://www.surveyb.in/configuration',
  },



  [NetworkNames.POLLFISH]: {
    image: staticImages.POLLFISH,
    url: 'https://www.pollfish.com',
  },

  [NetworkNames.LOOTABLY]: {
    image: staticImages.LOOTABLY,
    url: 'https://wall.lootably.com',
  },

  [NetworkNames.BITLABS]: {
    image: staticImages.BITLABS,
    url: 'https://web.bitlabs.ai',
  },

  [NetworkNames.TIMEWALL]: {
    image: staticImages.TIMEWALL,
    url: 'https://timewall.io/users/login',
  },
};